import React from 'react'
import { useTranslation } from 'react-i18next'
import { LmsUserProfile } from '@rankmi/lms-components'
import '@rankmi/lms-components/dist/index.css'
import Loader from 'components/ui/loader/Loader'
import { getToken } from 'helpers/cookies.helper'
import { translations } from 'components/configuration/components/userProfile/translations'

const MyCertificates: React.FC = () => {
  const { t } = useTranslation()
  const userToken = getToken().token

  if (!userToken) {
    return <Loader overlay color />
  }

  return (
    <LmsUserProfile
      locale={translations(t)}
      userToken={userToken}
      showCoursesTab={false}
      showAdvanceStats={false}
    />
  )
}

export default MyCertificates
